<template>
  <div ref="container" class="plv-ia-container plv-ia-aq">
    <pre-start
      v-show="status==='preStart'"
      :lang="lang"
      @start="start"
    />
    <in-answer
      v-show="status==='inAnswer'"
      :lang="lang"
      :over-time="overTime"
      :answer-num="answerNum"
      @stop="stop"
    />
    <answer-over
      v-show="status === 'answerOver'"
      :lang="lang"
      :statistics="statistics"
      @to-pre-start="handleToPreStart"
    />
  </div>
</template>

<script type="text/babel">
import Locale from '@/mixins/locale';
import PreStart from './PreStart.vue';
import InAnswer from './InAnswer.vue';
import AnswerOver from './AnswerOver.vue';
import commonMixin from '../app-mixin';

export default {
  name: 'RushAnswer',

  components: {
    PreStart,
    InAnswer,
    AnswerOver,
  },

  mixins: [commonMixin, Locale],

  props: {
    /** 抢答 SDK 实例 */
    core: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      status: 'preStart',
      overTime: 0,
      answerNum: 0,
      rushAnswerId: '',
      statistics: [],
      NETWORK_ERR: this.t('plvIA.common.networkErr'),
    };
  },

  timer: 0,

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    async afterCoreInited() {
      await this.updateStatus();
    },

    async start(limitTime) {
      const { overTime, rushAnswerId } = await this.core.start(limitTime);
      this.overTime = overTime;
      this.rushAnswerId = rushAnswerId;
      this.status = 'inAnswer';
      this.updateStatus();
    },

    clearTimer() {
      if (!this.$options.timer) return;
      clearInterval(this.$options.timer);
      this.$options.timer = 0;
    },

    // 获取抢答状态
    async updateStatus() {
      this.clearTimer();
      try {
        const { ongoingStatus, overTime, answerNum, rushAnswerId } = await this.core.getStatus();
        if (ongoingStatus) {
          this.status = 'inAnswer';
          this.overTime = overTime;
          this.answerNum = answerNum;
          this.rushAnswerId = rushAnswerId;
          this.$options.timer = setTimeout(this.updateStatus, 1000);
        } else {
          this.overTime = 0;
          if (this.status === 'inAnswer') {
            this.status = 'answerOver';
            this.getAnswerList();
          }
        }
      } catch (error) {
        this.clearTimer();
        if (this.status === 'inAnswer') {
          this.$iaMessage.default(error.message || this.NETWORK_ERR);
        }
      }
    },

    // 主动结束抢答
    stop() {
      this.core.stop(this.rushAnswerId);
    },

    handleToPreStart() {
      this.status = 'preStart';
    },

    async getAnswerList() {
      try {
        const answerList = await this.core.getAnswerList(this.rushAnswerId);
        this.statistics = answerList.sort((a, b) => a.useTime - b.useTime);
      } catch (error) {
        this.$iaMessage.default(error.message || this.NETWORK_ERR);
      }
    },
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/main.scss';

.plv-ia-aq {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
